module.exports = __webpack_public_path__ + "img/FAVICON-EK-gradient.a2a0e2c8.svg";